
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteBrand from "./ModalDeleteBrand";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const EncuestasList = ({
  pageActual,
  limitList,startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup,
  buscar_cis
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };

  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };
  return (
    <>
      <div className="cont-row-user-list">
        {dataUsers.loading ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={indice}
              >
                 {/* <div className="field-body-table-mantenimiento field-small">
                 <div className='cont-checkbox'>
                 <input type='checkbox' checked={poolRows.some((row) => row === elemento.brand_id)} className='NotifiCheckBox ' style={{height:'15px'}}  onClick={()=>rowSelected(elemento)} ></input>
                </div>
                </div> */}
                <div className="field-body-table-mantenimiento field-small">
                  {elemento.id}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'25%'}}>
                  {elemento.title}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.code}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'25%'}}>
                  {elemento.description}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.response_count}
                </div>
                
               
                
                
                <div className="field-body-table-mantenimiento field-larger">
                  {
                    (elemento.editable==0)?'':
                    <>
                    <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/review.png"
                    } 
                    onClick={()=>handleChangEdit(elemento)}
                    name="View" title="Ver Respuestas" className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div>
                  
                  {/* <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/delete.png"
                    } 
                    onClick={()=>handledeleteUserClick(elemento)}
                    name="Eliminar"  title='Eliminar' className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div> */}
                    </>
                  }
                  
                </div>
              </div>
            ))
        )}
        { dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteBrand handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteBrand>
    </Modal>
    </>
  );
};

export default EncuestasList;
